
addEventListener("load", _=> {
    App.homeSlider('#homeSlider');
})
